import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Layout } from 'tea-component';

import {
  FilterFixed,
  useFilterDataHook,
} from '@/pages/opinion/components/FilterCommon';
import { GameStoreMobileScore } from '@op/widgets/GameStorePlate';
import { useDispatch, useIntl } from 'umi';
import ScoreTrends from '../widgets/ScoreTrends';
import useGetStoreStats from '../hooks/useGetStoreStats';
import useGetStoreTimeline from '../hooks/useGetStoreTimeline';
import ByRegionOrCountry from '../widgets/ByRegionOrCountry';
import '@op/assets/scss/pages/gamestore/index.scss';
import CardLoading from '@op/components/CardLoading';
import { localStoreSaveCountryToRegion } from '@op/utils';
import { useInitBuriedPointInfo } from '@op/operationLog/buriedPoint';
import GameStorePoint from '@op/operationLog/pages/gameStore';
import { storage } from '@/utils/utils';
import { OPINION_GUIDE_BOX_LIST3 } from '@/pages/home/components/GuideModule/GuideOpinionBox';
import { GUIDE_TYPE_OPINION_GAME_STORE } from '@/pages/home/models/guide';
import ContentBody from '@op/components/ContentBody';

const { Content } = Layout;

export default function GameStore({ gameInfo, userInfo }: any) {
  useInitBuriedPointInfo({ buriedPoint: GameStorePoint });
  const {
    loading: initLoading,
    filter,
    changeFilter,
    scrollBody,
    filterOptions,
  } = useFilterDataHook({
    gameInfo,
    hasHero: true,
    pageName: 'GameStore',
  });

  const dispatch = useDispatch();

  useEffect(() => {
    const list = storage.getLocalStorageItem(OPINION_GUIDE_BOX_LIST3) || [];
    if (userInfo?.openid && !list.includes(userInfo.openid)) {
      dispatch({
        type: 'guide/save',
        payload: {
          guideSys: '',
          guideType: GUIDE_TYPE_OPINION_GAME_STORE,
        },
      });
    }
  }, [userInfo]);

  const defaultChannel = useRef<any>(['app store', 'google play', 'taptap']);
  const { formatMessage } = useIntl();

  const commonParams = useMemo(() => {
    return {
      ...(filter || {}),
      only_date_filter: true,
    };
  }, [filter]);

  const { userScore, userScoreLoading, userScoreApiError, userScoreTable } =
    useGetStoreStats({
      keepParams: commonParams,
      channel: defaultChannel.current,
      needLink: false,
      splitRegion: true,
    });

  const { userScoreTrendsLoading, allScoreTrendsTimeline } =
    useGetStoreTimeline({
      keepParams: commonParams,
      channel: defaultChannel.current,
      splitRegion: true,
    });

  const [originRegion, setOriginRegion] = useState([]);

  return (
    <Content className="dbo-page dbo-gamestore" ref={scrollBody}>
      <ContentBody
        contentHeard={
          <Content.Header title={formatMessage({ id: 'Game Store' })} />
        }
      >
        <FilterFixed
          filter={filterOptions}
          confirm={(value: any) => {
            changeFilter({
              ...value,
              ...gameInfo,
              social_media_by_account: ['99999'],
              social_media_by_keyword: ['99999'],
              external_data_sources: ['99999']
            });
          }}
          defaultConfig={{
            channel: {
              channelKey: 'comments',
            },
          }}
          beforeCacheDealwithData={() => false}
          operateShowOptions={['history', 'more']}
          backCondOriginData={(value) => {
            const { region_country } = value || {};
            setOriginRegion(region_country || []);
            localStoreSaveCountryToRegion(region_country);
          }}
        ></FilterFixed>
        <CardLoading loading={initLoading}>
          {/* 内部有6个UserScoreBox的时候加feeds-userscorebox--6，4个情况不加 */}
          <GameStoreMobileScore filter={filter} gameInfo={gameInfo} />

          <ScoreTrends
            filter={filter}
            gameInfo={gameInfo}
            channel={defaultChannel.current}
          ></ScoreTrends>

          <ByRegionOrCountry
            keepParams={filter}
            gameInfo={gameInfo}
            loading={userScoreTrendsLoading || userScoreLoading}
            userScoreTable={userScoreTable}
            trendsTimeline={allScoreTrendsTimeline}
            originRegion={originRegion}
          ></ByRegionOrCountry>
        </CardLoading>
      </ContentBody>
    </Content>
  );
}
